import React, { Component } from "react";
import {
	View,
	StyleSheet,
	TextInput,
	TouchableOpacity,
	Platform,
	Image,
	Dimensions,
} from "react-native";
import { translate } from "react-i18next";

import { push, reset } from "utils/navigation";
import Header from "components/Header";
import Textfield from "components/Textfield";
import Text from "components/StyledText";
import Button from "components/Button";
import validation from "utils/validation";
import ViewScroll from "components/ViewScroll";

import { confirmForgotPassword } from "utils/awsAuth";

import * as x from "styles/css";

class PasswordReset extends Component {
	static navigationOptions = {
		header: null,
	};

	constructor(props) {
		super(props);

		this.state = {
			inputs: { password: "", confirmPassword: "" },
			error: { password: "", confirmPassword: "" },
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
			loading: false,
			resetDone: false,
		};

		this.updateDimensions = this.updateDimensions.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
		this.goLogin = this.goLogin.bind(this);
	}

	updateDimensions(layout) {
		this.setState({
			width: layout.width,
			height: layout.height,
		});
	}

	goLogin() {
		reset({ web: "/login", mobile: "Login" }, this.props);
	}

	resetPassword() {
		const { inputs, error } = this.state;
		const { t } = this.props;

		this.setState({
			loading: true,
		});

		const validateInputs = validation(inputs);

		if (validateInputs) {
			Object.keys(validateInputs).forEach(
				x => (validateInputs[x] = validateInputs[x][0])
			);
			Object.keys(validateInputs).map((key, index) => {
				validateInputs[key] = this.props.t(validateInputs[key]);
			});
		}

		const msg = {};
		let errorFound = false;
		if (inputs.password !== inputs.confirmPassword) {
			msg.password = "Passwords must match";
			msg.confirmPassword = "Passwords must match";
			errorFound = true;
		}

		if (errorFound || validateInputs) {
			return this.setState({
				error: { ...validateInputs, ...msg },
				loading: false,
			});
		}

		confirmForgotPassword(
			this.props.match.params.username,
			this.props.match.params.token,
			inputs.password
		)
			.then(success => {
				this.setState({
					loading: false,
					resetDone: true,
				});
			})
			.catch(err => {
				this.setState({
					loading: false,
					error: { password: t(err.message) },
				});
			});
	}

	render() {
		const { inputs, error } = this.state;
		const { t } = this.props;

		return (
			<ViewScroll>
				<View>
					<Header>{t("passwordReset.title")}</Header>
					{this.state.resetDone ? (
						<View style={[x.px.three]}>
							<Text>{t("passwordReset.sent")}</Text>
							<View style={[x.flexDirection.row]}>
								<a
									href="https://www.coolbreeze.com.au/"
									target="_blank"
								/>
								<Text>{t("passwordReset.loginDesktop")}</Text>
								<TouchableOpacity onPress={this.goLogin}>
									<Text style={{ color: x.colors.default }}>
										{t("passwordReset.here")}
									</Text>
								</TouchableOpacity>
								<Text>{t("passwordReset.loginApp")}</Text>
							</View>
						</View>
					) : (
						<View style={[x.my.three]}>
							<Textfield
								label="New Password"
								error={error.password}
								value={inputs.password}
								onChangeText={password =>
									this.setState({
										inputs: { ...inputs, password },
									})
								}
								blurOnSubmit
								secureTextEntry
							/>
							<Textfield
								label="Confirm Password"
								error={error.confirmPassword}
								value={inputs.confirmPassword}
								onChangeText={confirmPassword =>
									this.setState({
										inputs: {
											...inputs,
											confirmPassword,
										},
									})
								}
								blurOnSubmit
								secureTextEntry
								onSubmitEditing={this.resetPassword}
								returnKeyType="done"
							/>
						</View>
					)}
					{!this.state.resetDone && (
						<Button
							onPress={this.resetPassword}
							disabled={this.state.loading}
							title={t("labels.resetPassword")}
							color={x.colors.default}
						/>
					)}
				</View>
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	app: {
		height: "100%",
	},
	body: {
		padding: 20,
		width: 800,
		minHeight: 800,
	},
	navigation: {
		backgroundColor: "white",
	},
	footerText: {
		color: "white",
	},
});

export default translate()(PasswordReset);



// WEBPACK FOOTER //
// ./src/views/PasswordReset/index.web.js